export default {
    "v": "5.7.1",
    "fr": 25,
    "ip": 0,
    "op": 200,
    "w": 1000,
    "h": 1000,
    "nm": "Work frome Home Mailing F 2",
    "ddd": 0,
    "assets": [],
    "layers": [{
        "ddd": 0,
        "ind": 1,
        "ty": 3,
        "nm": "Null 1",
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 0, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [500, 604, 0], "ix": 2},
            "a": {"a": 0, "k": [0, 0, 0], "ix": 1},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
        },
        "ao": 0,
        "ip": 0,
        "op": 200,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 2,
        "ty": 4,
        "nm": "mail 4",
        "parent": 1,
        "td": 1,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 99, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [183.055, -315.211, 0], "ix": 2},
            "a": {"a": 0, "k": [2153.478, 680.843, 0], "ix": 1},
            "s": {"a": 0, "k": [56, 56, 100], "ix": 6}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[-0.758, -2.403], [0, 0], [0, 0], [0, 0], [-21.953, -7.476], [-0.627, -0.393]],
                        "o": [[0, 0], [0, 0], [0, 0], [0, 0], [9.299, 3.167], [1.978, 1.239]],
                        "v": [[78.735, -34.708], [80.678, -28.718], [-58.964, 72.319], [-68.916, 40.154], [58.006, -46.114], [74.435, -40.273]],
                        "c": true
                    },
                    "ix": 2
                },
                "nm": "Path 4",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.174548238516, 0.452203959227, 0.890196084976, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 3",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [1801.139, 934.164], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [594, 594], "ix": 3},
                "r": {"a": 0, "k": 17.3, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "back 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 204,
        "st": -23,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 3,
        "ty": 4,
        "nm": "plane 2",
        "parent": 1,
        "tt": 2,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": -30.27, "ix": 10},
            "p": {
                "a": 1,
                "k": [{
                    "i": {"x": 0.57, "y": 1},
                    "o": {"x": 0.43, "y": 0},
                    "t": 0,
                    "s": [-417.664, 54.901, 0],
                    "to": [29.664, 67.099, 0],
                    "ti": [8.659, 75.131, 0]
                }, {
                    "i": {"x": 0.57, "y": 1},
                    "o": {"x": 0.444, "y": 0},
                    "t": 50,
                    "s": [384.659, -254.869, 0],
                    "to": [-6.219, -53.959, 0],
                    "ti": [-29.664, -67.099, 0]
                }, {
                    "i": {"x": 0.57, "y": 1},
                    "o": {"x": 0.43, "y": 0},
                    "t": 100,
                    "s": [-417.664, 54.901, 0],
                    "to": [29.664, 67.099, 0],
                    "ti": [8.659, 75.131, 0]
                }, {
                    "i": {"x": 0.595, "y": 1},
                    "o": {"x": 0.444, "y": 0},
                    "t": 150,
                    "s": [384.659, -254.869, 0],
                    "to": [-6.219, -53.959, 0],
                    "ti": [-17.336, -57.901, 0]
                }, {"t": 199, "s": [-417.664, 54.901, 0]}],
                "ix": 2
            },
            "a": {"a": 0, "k": [816.438, 755.113, 0], "ix": 1},
            "s": {"a": 0, "k": [65, 65, 100], "ix": 6}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr", "it": [{
                "ind": 0, "ty": "sh", "ix": 1, "ks": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": -7,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[18.514, -6.941], [-33.276, 21.927], [93.386, -0.562]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 3,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-6.915, -14.251], [-9.38, 40.839], [47.51, -30.24]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 12,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[21.986, -29.805], [113.019, 32.241], [42.547, -64.73]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 30,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-0.528, -14.328], [129.556, -5.673], [-49.243, -49.537]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 48,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[12.419, -8.39], [20.033, -35.22], [-88.885, -12.543]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.32, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 61,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[55.573, 8.709], [-40.935, -18.354], [28.444, 45.375]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 70,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[6.11, 3.203], [-110.008, -19.184], [7.061, 50.133]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 84,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[70.462, -13.025], [-68.13, -5.656], [131.7, 43.826]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 93,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[18.514, -6.941], [-33.276, 21.927], [93.387, -0.562]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 103,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-6.915, -14.251], [-9.38, 40.839], [47.51, -30.24]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 112,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[21.986, -29.805], [113.019, 32.241], [42.547, -64.73]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 130,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-0.528, -14.328], [129.556, -5.673], [-49.243, -49.537]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 148,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[12.419, -8.39], [20.033, -35.22], [-88.885, -12.543]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.32, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 161,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[55.573, 8.709], [-40.935, -18.354], [28.444, 45.375]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 170,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[6.11, 3.203], [-110.008, -19.184], [7.061, 50.133]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 184,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[70.462, -13.025], [-68.13, -5.656], [131.7, 43.826]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 193,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[18.514, -6.941], [-33.276, 21.927], [93.386, -0.562]],
                            "c": true
                        }]
                    }, {
                        "t": 203,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-6.915, -14.251], [-9.38, 40.839], [47.51, -30.24]],
                            "c": true
                        }]
                    }],
                    "ix": 2
                }, "nm": "Path 2", "mn": "ADBE Vector Shape - Group", "hd": false
            }, {
                "ind": 1, "ty": "sh", "ix": 2, "ks": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": -7,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-33.276, 21.927], [5.299, -10.555], [-29.451, -26.172]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 3,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-9.38, 40.839], [-24.162, -11.06], [-91.62, -22.853]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 12,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[113.019, 32.241], [-1.135, -26.615], [-113.019, -32.241]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 30,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[129.556, -5.673], [7.207, -4.426], [12.17, 72.534]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 48,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[20.033, -35.22], [24.82, -6.359], [108.512, 9]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.32, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 61,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-40.935, -18.354], [69.258, 0.624], [114.118, -27.203]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 70,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-110.008, -19.184], [15.525, -1.402], [54.092, -19.43]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 84,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-68.13, -5.656], [63.129, -26.565], [63.443, -50.053]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 93,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-33.276, 21.927], [5.299, -10.555], [-29.451, -26.172]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 103,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-9.38, 40.839], [-24.162, -11.06], [-91.62, -22.853]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 112,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[113.019, 32.241], [-1.135, -26.615], [-113.019, -32.241]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 130,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[129.556, -5.673], [7.207, -4.426], [12.17, 72.534]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 148,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[20.033, -35.22], [24.82, -6.359], [108.512, 9]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.32, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 161,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-40.935, -18.354], [69.258, 0.624], [114.118, -27.203]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 170,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-110.008, -19.184], [15.525, -1.402], [54.092, -19.43]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 184,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-68.13, -5.656], [63.129, -26.565], [63.443, -50.053]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 193,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-33.276, 21.927], [5.299, -10.555], [-29.451, -26.172]],
                            "c": true
                        }]
                    }, {
                        "t": 203,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-9.38, 40.839], [-24.162, -11.06], [-91.62, -22.853]],
                            "c": true
                        }]
                    }],
                    "ix": 2
                }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [1, 0.4823529411764706, 0.6745098039215687, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ind": 3, "ty": "sh", "ix": 4, "ks": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": -7,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-14.241, 3.304], [-30.454, 20.957], [19.514, -1.564], [11.823, 5.95], [3.437, -9.631]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 3,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-21.862, 17.885], [-9.38, 40.839], [-6.915, -14.251], [-10.368, 5.64], [-25.224, -7.275]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 12,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-24.159, 12.674], [113.019, 32.241], [21.986, -29.805], [17.357, -9.915], [-16.004, -3.872]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 30,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[55.35, -4.914], [129.556, -5.673], [-3.271, -18.353], [-13.529, 7.902], [42.148, 1]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 48,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[34.167, -10.201], [20.033, -35.22], [10.099, -7.209], [13.95, 35.083], [26.183, -5.636]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.32, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 61,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[75.86, -3.345], [-40.935, -18.354], [42.881, 12.14], [74.348, 24.549], [70.369, 1.013]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 70,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[12.51, -7.277], [-110.008, -19.184], [-19.192, 3.494], [20.236, 23.254], [16.22, -0.587]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 84,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-3.126, -17.964], [-61.192, -8.042], [72.921, 0.195], [59.046, -10.343], [60.098, -29.814]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 93,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-14.241, 3.304], [-30.454, 20.957], [19.514, -1.564], [11.823, 5.95], [3.437, -9.631]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 103,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-21.861, 17.885], [-9.38, 40.839], [-6.915, -14.251], [-10.368, 5.64], [-25.224, -7.275]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 112,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-24.159, 12.674], [113.019, 32.241], [21.986, -29.805], [17.357, -9.915], [-16.004, -3.872]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 130,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[55.35, -4.914], [129.556, -5.673], [-3.271, -18.353], [-13.529, 7.902], [42.148, 1]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 148,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[34.167, -10.201], [20.033, -35.22], [10.099, -7.209], [13.95, 35.083], [26.183, -5.636]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.32, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 161,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[75.86, -3.345], [-40.935, -18.354], [42.881, 12.14], [74.348, 24.549], [70.369, 1.013]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 170,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[12.51, -7.277], [-110.008, -19.184], [-19.192, 3.494], [20.236, 23.254], [16.22, -0.587]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 184,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-3.126, -17.964], [-61.192, -8.042], [72.921, 0.195], [59.046, -10.343], [60.098, -29.814]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 193,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-14.241, 3.304], [-30.454, 20.957], [19.514, -1.564], [11.823, 5.95], [3.437, -9.631]],
                            "c": true
                        }]
                    }, {
                        "t": 203,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-21.862, 17.885], [-9.38, 40.839], [-6.915, -14.251], [-10.368, 5.64], [-25.224, -7.275]],
                            "c": true
                        }]
                    }],
                    "ix": 2
                }, "nm": "Path 3", "mn": "ADBE Vector Shape - Group", "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.996078431372549, 0.4627450980392157, 0.611764705882353, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 2",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [795.902, 768.678], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }], "nm": "Group 9", "np": 5, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
        }, {
            "ty": "gr", "it": [{
                "ind": 0, "ty": "sh", "ix": 1, "ks": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": -7,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[18.514, -6.941], [-33.276, 21.927], [93.386, -0.562]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 3,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-6.915, -14.251], [-9.38, 40.839], [47.51, -30.24]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 12,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[21.986, -29.805], [113.019, 32.241], [42.547, -64.73]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 30,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-0.528, -14.328], [129.556, -5.673], [-49.243, -49.537]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 48,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[12.419, -8.39], [20.033, -35.22], [-88.885, -12.543]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.32, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 61,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[55.573, 8.709], [-40.935, -18.354], [28.444, 45.375]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 70,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[6.11, 3.203], [-110.008, -19.184], [7.061, 50.133]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 84,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[70.462, -13.025], [-68.13, -5.656], [131.7, 43.826]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 93,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[18.514, -6.941], [-33.276, 21.927], [93.387, -0.562]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 103,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-6.915, -14.251], [-9.38, 40.839], [47.51, -30.24]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 112,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[21.986, -29.805], [113.019, 32.241], [42.547, -64.73]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 130,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-0.528, -14.328], [129.556, -5.673], [-49.243, -49.537]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 148,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[12.419, -8.39], [20.033, -35.22], [-88.885, -12.543]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.32, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 161,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[55.573, 8.709], [-40.935, -18.354], [28.444, 45.375]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 170,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[6.11, 3.203], [-110.008, -19.184], [7.061, 50.133]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 184,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[70.462, -13.025], [-68.13, -5.656], [131.7, 43.826]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 193,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[18.514, -6.941], [-33.276, 21.927], [93.386, -0.562]],
                            "c": true
                        }]
                    }, {
                        "t": 203,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-6.915, -14.251], [-9.38, 40.839], [47.51, -30.24]],
                            "c": true
                        }]
                    }],
                    "ix": 2
                }, "nm": "Path 2", "mn": "ADBE Vector Shape - Group", "hd": false
            }, {
                "ind": 1, "ty": "sh", "ix": 2, "ks": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": -7,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-33.276, 21.927], [5.299, -10.555], [-29.451, -26.172]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 3,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-9.38, 40.839], [-24.162, -11.06], [-91.62, -22.853]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 12,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[113.019, 32.241], [-1.135, -26.615], [-113.019, -32.241]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 30,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[129.556, -5.673], [7.207, -4.426], [12.17, 72.534]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 48,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[20.033, -35.22], [24.82, -6.359], [108.512, 9]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.32, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 61,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-40.935, -18.354], [69.258, 0.624], [114.118, -27.203]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 70,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-110.008, -19.184], [15.525, -1.402], [54.092, -19.43]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 84,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-68.13, -5.656], [63.129, -26.565], [63.443, -50.053]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 93,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-33.276, 21.927], [5.299, -10.555], [-29.451, -26.172]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 103,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-9.38, 40.839], [-24.162, -11.06], [-91.62, -22.853]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 112,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[113.019, 32.241], [-1.135, -26.615], [-113.019, -32.241]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 130,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[129.556, -5.673], [7.207, -4.426], [12.17, 72.534]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 148,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[20.033, -35.22], [24.82, -6.359], [108.512, 9]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.32, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 161,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-40.935, -18.354], [69.258, 0.624], [114.118, -27.203]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 170,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-110.008, -19.184], [15.525, -1.402], [54.092, -19.43]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 184,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-68.13, -5.656], [63.129, -26.565], [63.443, -50.053]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 193,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-33.276, 21.927], [5.299, -10.555], [-29.451, -26.172]],
                            "c": true
                        }]
                    }, {
                        "t": 203,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0]],
                            "v": [[-9.38, 40.839], [-24.162, -11.06], [-91.62, -22.853]],
                            "c": true
                        }]
                    }],
                    "ix": 2
                }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
            }, {
                "ind": 2, "ty": "sh", "ix": 3, "ks": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": -7,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-14.241, 3.304], [-30.454, 20.957], [19.514, -1.564], [11.823, 5.95], [3.437, -9.631]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 3,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-21.862, 17.885], [-9.38, 40.839], [-6.915, -14.251], [-10.368, 5.64], [-25.224, -7.275]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 12,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-24.159, 12.674], [113.019, 32.241], [21.986, -29.805], [17.357, -9.915], [-16.004, -3.872]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 30,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[55.35, -4.914], [129.556, -5.673], [-3.271, -18.353], [-13.529, 7.902], [42.148, 1]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 48,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[34.167, -10.201], [20.033, -35.22], [10.099, -7.209], [13.95, 35.083], [26.183, -5.636]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.32, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 61,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[75.86, -3.345], [-40.935, -18.354], [42.881, 12.14], [74.348, 24.549], [70.369, 1.013]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 70,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[12.51, -7.277], [-110.008, -19.184], [-19.192, 3.494], [20.236, 23.254], [16.22, -0.587]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 84,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-3.126, -17.964], [-61.192, -8.042], [72.921, 0.195], [59.046, -10.343], [60.098, -29.814]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 93,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-14.241, 3.304], [-30.454, 20.957], [19.514, -1.564], [11.823, 5.95], [3.437, -9.631]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 103,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-21.861, 17.885], [-9.38, 40.839], [-6.915, -14.251], [-10.368, 5.64], [-25.224, -7.275]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 112,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-24.159, 12.674], [113.019, 32.241], [21.986, -29.805], [17.357, -9.915], [-16.004, -3.872]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 130,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[55.35, -4.914], [129.556, -5.673], [-3.271, -18.353], [-13.529, 7.902], [42.148, 1]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 148,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[34.167, -10.201], [20.033, -35.22], [10.099, -7.209], [13.95, 35.083], [26.183, -5.636]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.32, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 161,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[75.86, -3.345], [-40.935, -18.354], [42.881, 12.14], [74.348, 24.549], [70.369, 1.013]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.667, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 170,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[12.51, -7.277], [-110.008, -19.184], [-19.192, 3.494], [20.236, 23.254], [16.22, -0.587]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.333, "y": 0},
                        "t": 184,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-3.126, -17.964], [-61.192, -8.042], [72.921, 0.195], [59.046, -10.343], [60.098, -29.814]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 193,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-14.241, 3.304], [-30.454, 20.957], [19.514, -1.564], [11.823, 5.95], [3.437, -9.631]],
                            "c": true
                        }]
                    }, {
                        "t": 203,
                        "s": [{
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-21.862, 17.885], [-9.38, 40.839], [-6.915, -14.251], [-10.368, 5.64], [-25.224, -7.275]],
                            "c": true
                        }]
                    }],
                    "ix": 2
                }, "nm": "Path 3", "mn": "ADBE Vector Shape - Group", "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.10196078431372549, 0.10196078431372549, 0.10196078431372549, 1], "ix": 4},
                "o": {"a": 0, "k": 20, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 2",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [790.902, 773.678], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }], "nm": "Group 8", "np": 4, "cix": 2, "bm": 0, "ix": 2, "mn": "ADBE Vector Group", "hd": false
        }],
        "ip": -2,
        "op": 201,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 4,
        "ty": 4,
        "nm": "Shape Layer 9",
        "parent": 1,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {
                "a": 1,
                "k": [{
                    "i": {"x": 0.833, "y": 0.833},
                    "o": {"x": 0.167, "y": 0.167},
                    "t": 0,
                    "s": [141.25, 25, 0],
                    "to": [-3.73, -1.383, 0],
                    "ti": [-8.37, -1.955, 0]
                }, {
                    "i": {"x": 0.833, "y": 0.833},
                    "o": {"x": 0.167, "y": 0.167},
                    "t": 38,
                    "s": [146.62, 14.455, 0],
                    "to": [5.12, 2.58, 0],
                    "ti": [5.195, 1.594, 0]
                }, {
                    "i": {"x": 0.833, "y": 0.833},
                    "o": {"x": 0.167, "y": 0.167},
                    "t": 75,
                    "s": [150.18, 5.281, 0],
                    "to": [-5.195, -1.594, 0],
                    "ti": [-0.953, -5.614, 0]
                }, {
                    "i": {"x": 0.833, "y": 0.833},
                    "o": {"x": 0.167, "y": 0.167},
                    "t": 106,
                    "s": [134.453, 14.614, 0],
                    "to": [0.953, 5.614, 0],
                    "ti": [-3.875, 4.525, 0]
                }, {
                    "i": {"x": 0.833, "y": 0.833},
                    "o": {"x": 0.167, "y": 0.167},
                    "t": 137,
                    "s": [149.75, 10.975, 0],
                    "to": [3.875, -4.525, 0],
                    "ti": [1.75, -5.25, 0]
                }, {
                    "i": {"x": 0.833, "y": 0.833},
                    "o": {"x": 0.167, "y": 0.167},
                    "t": 170,
                    "s": [140.625, 8.625, 0],
                    "to": [-1.75, 5.25, 0],
                    "ti": [11.125, -4.375, 0]
                }, {"t": 199, "s": [141.25, 25, 0]}],
                "ix": 2
            },
            "a": {"a": 0, "k": [197.25, -284, 0], "ix": 1},
            "s": {"a": 0, "k": [82, 82, 100], "ix": 6}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0]],
                        "v": [[192.5, -319.5], [250.5, -319.5]],
                        "c": false
                    },
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "st",
                "c": {"a": 0, "k": [0.3764705882352941, 0.44313725490196076, 1, 1], "ix": 3},
                "o": {"a": 0, "k": 100, "ix": 4},
                "w": {"a": 0, "k": 10, "ix": 5},
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [0, 0], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Shape 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }, {
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {"i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[192.5, -298], [313, -298]], "c": false},
                    "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "rp",
                "c": {"a": 0, "k": 3, "ix": 1},
                "o": {"a": 0, "k": 0, "ix": 2},
                "m": 1,
                "ix": 2,
                "tr": {
                    "ty": "tr",
                    "p": {"a": 0, "k": [0, 21], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 4},
                    "so": {"a": 0, "k": 100, "ix": 5},
                    "eo": {"a": 0, "k": 100, "ix": 6},
                    "nm": "Transform"
                },
                "nm": "Repeater 1",
                "mn": "ADBE Vector Filter - Repeater",
                "hd": false
            }, {
                "ty": "st",
                "c": {"a": 0, "k": [1, 0.4823529411764706, 0.6745098039215687, 1], "ix": 3},
                "o": {"a": 0, "k": 100, "ix": 4},
                "w": {"a": 0, "k": 10, "ix": 5},
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [0, 0], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Shape 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
        }, {
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[-10.631, 0], [0, -10.631], [8.016, -3.698], [-1.065, -13.634], [13.375, 0], [4.627, 5.177], [1.051, 0.57], [0, 8.437]],
                        "o": [[10.631, 0], [0, 8.766], [-0.831, 0.384], [-4.815, 6.616], [-14.376, 0], [0.627, -13.698], [-7.554, -4.095], [0, -10.631]],
                        "v": [[-74, -32], [-54.75, -12.75], [-68.625, 11.021], [-43.935, 27.259], [-74, 40.25], [-105.002, 26.948], [-80.268, 10.573], [-93.25, -12.75]],
                        "c": true
                    },
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [1, 1, 1, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 3",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "d": 1,
                "ty": "el",
                "s": {"a": 0, "k": [93.5, 93.5], "ix": 2},
                "p": {"a": 0, "k": [-74, 0], "ix": 3},
                "nm": "Ellipse Path 2",
                "mn": "ADBE Vector Shape - Ellipse",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.3764705882352941, 0.44313725490196076, 1, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 2",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "rc",
                "d": 1,
                "s": {"a": 0, "k": [267.5, 111], "ix": 2},
                "p": {"a": 0, "k": [0, 0], "ix": 3},
                "r": {"a": 0, "k": 10, "ix": 4},
                "nm": "Rectangle Path 1",
                "mn": "ADBE Vector Shape - Rect",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [1, 1, 1, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "rc",
                "d": 1,
                "s": {"a": 0, "k": [267.5, 111], "ix": 2},
                "p": {"a": 0, "k": [-6, 6], "ix": 3},
                "r": {"a": 0, "k": 10, "ix": 4},
                "nm": "Rectangle Path 2",
                "mn": "ADBE Vector Shape - Rect",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0, 0, 0, 1], "ix": 4},
                "o": {"a": 0, "k": 17, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 4",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [200.25, -287], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Rectangle 1",
            "np": 8,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 200,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0, "ind": 5, "ty": 4, "nm": "mail 6", "parent": 1, "sr": 1, "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {
                "a": 1,
                "k": [{
                    "i": {"x": [0.667], "y": [1]},
                    "o": {"x": [0.333], "y": [0]},
                    "t": 0,
                    "s": [0]
                }, {
                    "i": {"x": [0.667], "y": [1]},
                    "o": {"x": [0.333], "y": [0]},
                    "t": 22,
                    "s": [15.427]
                }, {
                    "i": {"x": [0.667], "y": [1]},
                    "o": {"x": [0.333], "y": [0]},
                    "t": 56,
                    "s": [-12.946]
                }, {
                    "i": {"x": [0.667], "y": [1]},
                    "o": {"x": [0.333], "y": [0]},
                    "t": 90,
                    "s": [28.456]
                }, {
                    "i": {"x": [0.667], "y": [1]},
                    "o": {"x": [0.333], "y": [0]},
                    "t": 126,
                    "s": [-12.946]
                }, {"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 167, "s": [24]}, {
                    "t": 199,
                    "s": [0]
                }],
                "ix": 10
            },
            "p": {
                "a": 1,
                "k": [{
                    "i": {"x": 0.833, "y": 0.833},
                    "o": {"x": 0.167, "y": 0.167},
                    "t": 0,
                    "s": [-192.052, -110.008, 0],
                    "to": [2.552, 4.383, 0],
                    "ti": [6.537, 13.177, 0]
                }, {
                    "i": {"x": 0.833, "y": 0.833},
                    "o": {"x": 0.167, "y": 0.167},
                    "t": 51,
                    "s": [-171.912, -105.677, 0],
                    "to": [-6.537, -13.177, 0],
                    "ti": [6.357, -1.675, 0]
                }, {
                    "i": {"x": 0.833, "y": 0.833},
                    "o": {"x": 0.167, "y": 0.167},
                    "t": 85,
                    "s": [-191.107, -93.45, 0],
                    "to": [-6.357, 1.675, 0],
                    "ti": [8.571, -10.521, 0]
                }, {
                    "i": {"x": 0.833, "y": 0.833},
                    "o": {"x": 0.167, "y": 0.167},
                    "t": 124,
                    "s": [-212.946, -117.604, 0],
                    "to": [-8.571, 10.521, 0],
                    "ti": [9.927, 9.883, 0]
                }, {
                    "i": {"x": 0.833, "y": 0.833},
                    "o": {"x": 0.167, "y": 0.167},
                    "t": 163,
                    "s": [-174.552, -122.008, 0],
                    "to": [-9.927, -9.883, 0],
                    "ti": [-4.323, -4.992, 0]
                }, {"t": 199, "s": [-192.052, -110.008, 0]}],
                "ix": 2
            },
            "a": {"a": 0, "k": [2153.478, 680.843, 0], "ix": 1},
            "s": {"a": 0, "k": [67, 67, 100], "ix": 6}
        }, "ao": 0, "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[0, 0], [4.932, 0], [0, 5.066], [-8.798, 0], [-1.066, -0.267]],
                        "o": [[-1.2, 7.732], [-4.398, 0], [0, -10.264], [1.732, 0], [0, 0]],
                        "v": [[6.604, -0.329], [-4.726, 13.668], [-11.391, 5.403], [4.339, -13.526], [8.47, -12.993]],
                        "c": true
                    },
                    "ix": 2
                },
                "nm": "@",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[0, 0], [6.798, 0], [0, 22.262], [-20.396, 0], [0, -17.33], [5.73, 0.205], [-1.333, 7.865], [0, 0], [5.865, 0], [0, -16.263], [-8.665, 0], [-4.133, 6.799], [0, 0], [-6.266, 0], [0, 19.462], [23.461, 0], [0, -27.194], [-22.127, 0], [-7.998, 3.599]],
                        "o": [[-5.333, 2.799], [-19.862, 0], [0, -25.461], [20.662, 0], [0, 15.33], [-3.732, -0.133], [0, 0], [-3.333, -1.866], [-19.196, 0], [0, 10.931], [7.065, 0], [0, 0], [0.667, 7.065], [14.396, 0], [0, -22.395], [-30.127, 0], [0, 26.128], [9.465, 0], [0, 0]],
                        "v": [[17.936, 34.33], [-1.393, 38.596], [-35.519, 3.67], [2.74, -37.787], [34.598, -6.994], [21.668, 15.534], [18.336, 3.937], [22.335, -20.724], [6.472, -24.057], [-24.722, 7.003], [-9.791, 24.332], [7.405, 14.068], [7.671, 14.068], [19.136, 24.332], [44.463, -7.394], [4.206, -45.919], [-45.65, 4.87], [-4.06, 46.861], [20.335, 42.062]],
                        "c": true
                    },
                    "ix": 2
                },
                "nm": "@ 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.21176470588235294, 0.2549019607843137, 0.6196078431372549, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 3",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "d": 1,
                "ty": "el",
                "s": {"a": 0, "k": [126.905, 126.905], "ix": 2},
                "p": {"a": 0, "k": [0, 0], "ix": 3},
                "nm": "Ellipse Path 1",
                "mn": "ADBE Vector Shape - Ellipse",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.885428667068, 0.920325279236, 0.960784316063, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 2",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [2140.425, 652.021], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Group 5",
            "np": 5,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }, {
            "ty": "gr",
            "it": [{
                "d": 1,
                "ty": "el",
                "s": {"a": 0, "k": [126.905, 126.905], "ix": 2},
                "p": {"a": 0, "k": [-4, 11], "ix": 3},
                "nm": "Ellipse Path 1",
                "mn": "ADBE Vector Shape - Ellipse",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0, 0, 0, 1], "ix": 4},
                "o": {"a": 0, "k": 18, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 2",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [2140.425, 652.021], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Group 4",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
        }], "ip": 0, "op": 200, "st": 0, "bm": 0
    }, {
        "ddd": 0,
        "ind": 6,
        "ty": 4,
        "nm": "mail 3",
        "parent": 1,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 99, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [183.055, -315.211, 0], "ix": 2},
            "a": {"a": 0, "k": [2153.478, 680.843, 0], "ix": 1},
            "s": {"a": 0, "k": [56, 56, 100], "ix": 6}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr", "it": [{
                "ind": 0, "ty": "sh", "ix": 1, "ks": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 1, "y": 0},
                        "t": 5,
                        "s": [{
                            "i": [[1.212, 0.293], [-0.053, 1.063], [-0.465, 1.092], [-2.964, 0.923], [0, 0], [-2.408, -1.462], [-0.75, -0.938], [9.093, -10.048]],
                            "o": [[-13.028, -3.146], [0.06, -1.209], [1.127, -2.65], [0, 0], [2.9, -0.902], [1.008, 0.612], [0.699, 0.874], [-0.845, 0.934]],
                            "v": [[11.967, 33.017], [-77.516, 10.287], [-76.716, 6.809], [-70.385, 1.081], [66.005, -41.368], [74.313, -40.349], [76.976, -38.011], [15.15, 32.025]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 10,
                        "s": [{
                            "i": [[1.113, -0.027], [12.953, -2.709], [-0.38, 0.852], [-2.964, 0.923], [0, 0], [-2.227, -0.88], [0.429, -0.708], [10.164, -6.61]],
                            "o": [[-11.959, 0.286], [-0.893, -0.313], [0.756, -1.716], [0, 0], [2.9, -0.903], [0.932, 0.368], [-12.428, 5.23], [-0.945, 0.614]],
                            "v": [[4.34, 8.53], [-73.957, 7.989], [-75.054, 6.191], [-70.014, 2.274], [66.374, -40.184], [72.789, -39.988], [73.406, -38.058], [7.523, 7.538]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 11,
                        "s": [{
                            "i": [[1.022, -0.318], [22.981, -7.154], [-0.472, 0.148], [-2.964, 0.923], [0, 0], [-1.781, 0.553], [1.404, -0.438], [11.142, -3.471]],
                            "o": [[-10.983, 3.42], [-1.629, 0.507], [0.69, -0.217], [0, 0], [2.899, -0.903], [0.745, -0.231], [-23.438, 7.303], [-1.036, 0.323]],
                            "v": [[-4.379, -19.464], [-72.465, 1.734], [-74.732, 2.437], [-70.385, 1.081], [65.996, -41.397], [70.589, -42.826], [69.196, -42.389], [-1.196, -20.456]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 12,
                        "s": [{
                            "i": [[0, 0], [0.003, -0.005], [-0.001, -0.001], [-0.001, 0], [0, 0], [0.001, 0.003], [0, 0], [0.002, 0]],
                            "o": [[-0.002, 0.002], [0, 0], [0.001, 0.002], [0, 0], [0.001, 0], [0, -0.001], [-0.005, -0.003], [0, 0]],
                            "v": [[-73.926, 5.759], [-73.934, 5.774], [-73.933, 5.778], [-73.932, 5.781], [-73.908, 5.773], [-73.908, 5.77], [-73.909, 5.767], [-73.925, 5.759]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 87,
                        "s": [{
                            "i": [[0, 0], [0.003, -0.005], [-0.001, -0.001], [0, 0], [0, 0], [0.001, 0.003], [0, 0], [0.002, 0]],
                            "o": [[-0.001, 0.002], [0, 0], [0.001, 0.002], [0, 0], [0, 0], [0, -0.001], [-0.005, -0.003], [0, 0]],
                            "v": [[-73.926, 5.759], [-73.934, 5.774], [-73.933, 5.778], [-73.932, 5.781], [-73.908, 5.773], [-73.908, 5.77], [-73.909, 5.767], [-73.925, 5.759]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 88,
                        "s": [{
                            "i": [[1.022, -0.318], [22.981, -7.154], [-0.472, 0.148], [-2.964, 0.923], [0, 0], [-1.781, 0.552], [1.404, -0.438], [11.142, -3.471]],
                            "o": [[-10.983, 3.42], [-1.629, 0.507], [0.69, -0.217], [0, 0], [2.899, -0.903], [0.745, -0.231], [-23.438, 7.303], [-1.036, 0.323]],
                            "v": [[-4.379, -19.464], [-72.465, 1.734], [-74.732, 2.437], [-70.385, 1.081], [65.996, -41.397], [70.589, -42.826], [69.197, -42.389], [-1.196, -20.456]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 89,
                        "s": [{
                            "i": [[1.113, -0.027], [12.953, -2.709], [-0.38, 0.852], [-2.964, 0.923], [0, 0], [-2.227, -0.88], [0.429, -0.708], [10.164, -6.61]],
                            "o": [[-11.959, 0.286], [-0.893, -0.313], [0.756, -1.716], [0, 0], [2.9, -0.903], [0.932, 0.368], [-12.428, 5.23], [-0.945, 0.614]],
                            "v": [[4.34, 8.53], [-73.957, 7.989], [-75.054, 6.191], [-70.014, 2.274], [66.374, -40.184], [72.789, -39.988], [73.406, -38.058], [7.523, 7.538]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 1},
                        "o": {"x": 0.167, "y": 0},
                        "t": 94,
                        "s": [{
                            "i": [[1.212, 0.293], [-0.052, 1.063], [-0.465, 1.092], [-2.964, 0.923], [0, 0], [-2.408, -1.462], [-0.75, -0.938], [9.093, -10.048]],
                            "o": [[-13.028, -3.146], [0.06, -1.209], [1.127, -2.65], [0, 0], [2.9, -0.902], [1.008, 0.612], [0.699, 0.874], [-0.845, 0.934]],
                            "v": [[11.967, 33.017], [-77.516, 10.287], [-76.716, 6.809], [-70.385, 1.081], [66.005, -41.368], [74.313, -40.349], [76.976, -38.011], [15.15, 32.025]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 1, "y": 0},
                        "t": 106,
                        "s": [{
                            "i": [[1.212, 0.293], [-0.052, 1.063], [-0.465, 1.092], [-2.964, 0.923], [0, 0], [-2.408, -1.462], [-0.75, -0.938], [9.093, -10.048]],
                            "o": [[-13.028, -3.146], [0.06, -1.209], [1.127, -2.65], [0, 0], [2.9, -0.902], [1.008, 0.612], [0.699, 0.874], [-0.845, 0.934]],
                            "v": [[11.967, 33.017], [-77.516, 10.287], [-76.716, 6.809], [-70.385, 1.081], [66.005, -41.368], [74.313, -40.349], [76.976, -38.011], [15.15, 32.025]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 111,
                        "s": [{
                            "i": [[1.113, -0.027], [12.953, -2.709], [-0.38, 0.852], [-2.964, 0.923], [0, 0], [-2.227, -0.88], [0.429, -0.708], [10.164, -6.61]],
                            "o": [[-11.959, 0.286], [-0.893, -0.313], [0.756, -1.716], [0, 0], [2.9, -0.903], [0.932, 0.368], [-12.428, 5.23], [-0.945, 0.614]],
                            "v": [[4.34, 8.53], [-73.957, 7.989], [-75.054, 6.191], [-70.014, 2.274], [66.374, -40.184], [72.789, -39.988], [73.406, -38.058], [7.523, 7.538]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 112,
                        "s": [{
                            "i": [[1.022, -0.318], [22.981, -7.154], [-0.472, 0.148], [-2.964, 0.923], [0, 0], [-1.781, 0.552], [1.404, -0.438], [11.142, -3.471]],
                            "o": [[-10.983, 3.42], [-1.629, 0.507], [0.69, -0.217], [0, 0], [2.899, -0.903], [0.745, -0.231], [-23.438, 7.303], [-1.036, 0.323]],
                            "v": [[-4.379, -19.464], [-72.465, 1.734], [-74.732, 2.437], [-70.385, 1.081], [65.996, -41.397], [70.589, -42.826], [69.197, -42.389], [-1.196, -20.456]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 113,
                        "s": [{
                            "i": [[0, 0], [0.003, -0.005], [-0.001, -0.001], [0, 0], [0, 0], [0.001, 0.003], [0, 0], [0.002, 0]],
                            "o": [[-0.001, 0.002], [0, 0], [0.001, 0.002], [0, 0], [0, 0], [0, -0.001], [-0.005, -0.003], [0, 0]],
                            "v": [[-73.926, 5.759], [-73.934, 5.774], [-73.933, 5.778], [-73.932, 5.781], [-73.908, 5.773], [-73.908, 5.77], [-73.909, 5.767], [-73.925, 5.759]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 188,
                        "s": [{
                            "i": [[0, 0], [0.003, -0.005], [-0.001, -0.001], [0, 0], [0, 0], [0.001, 0.003], [0, 0], [0.002, 0]],
                            "o": [[-0.001, 0.002], [0, 0], [0.001, 0.002], [0, 0], [0, 0], [0, -0.001], [-0.005, -0.003], [0, 0]],
                            "v": [[-73.926, 5.759], [-73.934, 5.774], [-73.933, 5.778], [-73.932, 5.781], [-73.908, 5.773], [-73.908, 5.77], [-73.909, 5.767], [-73.925, 5.759]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 189,
                        "s": [{
                            "i": [[1.022, -0.318], [22.981, -7.154], [-0.472, 0.148], [-2.964, 0.923], [0, 0], [-1.781, 0.552], [1.404, -0.438], [11.142, -3.471]],
                            "o": [[-10.983, 3.42], [-1.629, 0.507], [0.69, -0.217], [0, 0], [2.899, -0.903], [0.745, -0.231], [-23.438, 7.303], [-1.036, 0.323]],
                            "v": [[-4.379, -19.464], [-72.465, 1.734], [-74.732, 2.437], [-70.385, 1.081], [65.996, -41.397], [70.589, -42.826], [69.197, -42.389], [-1.196, -20.456]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 190,
                        "s": [{
                            "i": [[1.113, -0.027], [12.953, -2.709], [-0.38, 0.852], [-2.964, 0.923], [0, 0], [-2.227, -0.88], [0.429, -0.708], [10.164, -6.61]],
                            "o": [[-11.959, 0.286], [-0.893, -0.313], [0.756, -1.716], [0, 0], [2.9, -0.903], [0.932, 0.368], [-12.428, 5.23], [-0.945, 0.614]],
                            "v": [[4.34, 8.53], [-73.957, 7.989], [-75.054, 6.191], [-70.014, 2.274], [66.374, -40.184], [72.789, -39.988], [73.406, -38.058], [7.523, 7.538]],
                            "c": true
                        }]
                    }, {
                        "t": 195,
                        "s": [{
                            "i": [[1.212, 0.293], [-0.052, 1.063], [-0.465, 1.092], [-2.964, 0.923], [0, 0], [-2.408, -1.462], [-0.75, -0.938], [9.093, -10.048]],
                            "o": [[-13.028, -3.146], [0.06, -1.209], [1.127, -2.65], [0, 0], [2.9, -0.902], [1.008, 0.612], [0.699, 0.874], [-0.845, 0.934]],
                            "v": [[11.967, 33.017], [-77.516, 10.287], [-76.716, 6.809], [-70.385, 1.081], [66.005, -41.368], [74.313, -40.349], [76.976, -38.011], [15.15, 32.025]],
                            "c": true
                        }]
                    }],
                    "ix": 2
                }, "nm": "Path 6", "mn": "ADBE Vector Shape - Group", "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.21176470588235294, 0.2549019607843137, 0.6196078431372549, 1], "ix": 4},
                "o": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.833], "y": [0.833]},
                        "o": {"x": [0.167], "y": [0.167]},
                        "t": 10,
                        "s": [100]
                    }, {
                        "i": {"x": [0.833], "y": [0.833]},
                        "o": {"x": [0.167], "y": [0.167]},
                        "t": 11,
                        "s": [0]
                    }, {
                        "i": {"x": [0.833], "y": [0.833]},
                        "o": {"x": [0.167], "y": [0.167]},
                        "t": 87,
                        "s": [0]
                    }, {
                        "i": {"x": [0.833], "y": [0.833]},
                        "o": {"x": [0.167], "y": [0.167]},
                        "t": 88,
                        "s": [100]
                    }, {
                        "i": {"x": [0.833], "y": [0.833]},
                        "o": {"x": [0.167], "y": [0.167]},
                        "t": 111,
                        "s": [100]
                    }, {
                        "i": {"x": [0.833], "y": [0.833]},
                        "o": {"x": [0.167], "y": [0.167]},
                        "t": 112,
                        "s": [0]
                    }, {
                        "i": {"x": [0.833], "y": [0.833]},
                        "o": {"x": [0.167], "y": [0.167]},
                        "t": 188,
                        "s": [0]
                    }, {"t": 189, "s": [100]}],
                    "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 6",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ind": 2,
                "ty": "sh",
                "ix": 3,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[0, 0], [4.2, -1.308], [0, 0], [2.5, 3.352], [0, 0], [-2.717, 0.813], [0, 0]],
                        "o": [[-0.18, 4.162], [0, 0], [-4.22, 1.315], [0, 0], [0, 0], [2.717, -0.813], [0, 0]],
                        "v": [[103.625, 47.302], [96.485, 56.565], [-39.905, 99.014], [-51.065, 95.387], [5.902, 26.402], [11.27, 22.465], [17.541, 22.927]],
                        "c": true
                    },
                    "ix": 2
                },
                "nm": "Path 5",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.3764705882352941, 0.44313725490196076, 1, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 5",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ind": 4,
                "ty": "sh",
                "ix": 5,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[0, 0], [4.2, -1.308], [0, 0], [2.53, 3.45], [0, 0], [-2.717, 0.812], [0, 0]],
                        "o": [[-0.149, 4.26], [0, 0], [-4.22, 1.315], [0, 0], [0, 0], [2.717, -0.812], [0, 0]],
                        "v": [[103.573, 47.134], [96.485, 56.565], [-39.905, 99.013], [-51.118, 95.217], [5.469, 25.011], [10.82, 21.02], [17.108, 21.54]],
                        "c": true
                    },
                    "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.10196078431372549, 0.10196078431372549, 0.10196078431372549, 1], "ix": 4},
                "o": {"a": 0, "k": 30, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 2",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ind": 6,
                "ty": "sh",
                "ix": 7,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[-1.69, -5.354], [0, 0], [0.05, -1.142], [4.2, -1.308], [0, 0], [2.5, 3.352], [0.36, 1.136], [0, 0], [-6.374, -1.622], [0, 0], [0, 0]],
                        "o": [[0, 0], [0.36, 1.157], [-0.18, 4.162], [0, 0], [-4.22, 1.315], [-0.68, -0.903], [0, 0], [-1.67, -5.372], [0, 0], [0, 0], [4.139, -4.613]],
                        "v": [[78.958, -33.99], [103.175, 43.824], [103.625, 47.302], [96.485, 56.565], [-39.905, 99.014], [-51.065, 95.387], [-52.635, 92.318], [-76.841, 14.537], [-68.329, 7.683], [12.317, 29.181], [68.061, -34.766]],
                        "c": true
                    },
                    "ix": 2
                },
                "nm": "Path 3",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.21176470588235294, 0.2549019607843137, 0.6196078431372549, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 4",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [1801.139, 934.164], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [594, 594], "ix": 3},
                "r": {"a": 0, "k": 17.3, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }], "nm": "front", "np": 8, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
        }, {
            "ty": "gr", "it": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0]],
                            "v": [[1741.752, 1155.556], [1787.515, 1141.378]],
                            "c": false
                        },
                        "ix": 2
                    },
                    "nm": "Path 6",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0]],
                            "v": [[1746.435, 1170.589], [1844.124, 1140.151]],
                            "c": false
                        },
                        "ix": 2
                    },
                    "nm": "Path 5",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "rp",
                    "c": {"a": 0, "k": 4, "ix": 1},
                    "o": {"a": 0, "k": 0, "ix": 2},
                    "m": 1,
                    "ix": 3,
                    "tr": {
                        "ty": "tr",
                        "p": {"a": 0, "k": [5, 15], "ix": 2},
                        "a": {"a": 0, "k": [0, 0], "ix": 1},
                        "s": {"a": 0, "k": [100, 100], "ix": 3},
                        "r": {"a": 0, "k": 0, "ix": 4},
                        "so": {"a": 0, "k": 100, "ix": 5},
                        "eo": {"a": 0, "k": 100, "ix": 6},
                        "nm": "Transform"
                    },
                    "nm": "Repeater 1",
                    "mn": "ADBE Vector Filter - Repeater",
                    "hd": false
                }, {
                    "ty": "tm",
                    "s": {"a": 0, "k": 0, "ix": 1},
                    "e": {
                        "a": 1,
                        "k": [{
                            "i": {"x": [0.667], "y": [1]},
                            "o": {"x": [0.333], "y": [0]},
                            "t": 17,
                            "s": [0]
                        }, {
                            "i": {"x": [0.667], "y": [1]},
                            "o": {"x": [0.167], "y": [0]},
                            "t": 46,
                            "s": [100]
                        }, {
                            "i": {"x": [0.833], "y": [1]},
                            "o": {"x": [0.167], "y": [0]},
                            "t": 105,
                            "s": [100]
                        }, {
                            "i": {"x": [0.833], "y": [1]},
                            "o": {"x": [0.333], "y": [0]},
                            "t": 106,
                            "s": [0]
                        }, {
                            "i": {"x": [0.667], "y": [1]},
                            "o": {"x": [0.333], "y": [0]},
                            "t": 118,
                            "s": [0]
                        }, {"t": 147, "s": [100]}],
                        "ix": 2
                    },
                    "o": {"a": 0, "k": 0, "ix": 3},
                    "m": 2,
                    "ix": 4,
                    "nm": "Trim Paths 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }, {
                    "ty": "st",
                    "c": {"a": 0, "k": [0.3764705882352941, 0.44313725490196076, 1, 1], "ix": 3},
                    "o": {"a": 0, "k": 100, "ix": 4},
                    "w": {"a": 0, "k": 5, "ix": 5},
                    "lc": 2,
                    "lj": 2,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "mn": "ADBE Vector Graphic - Stroke",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [-1792, -1153], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 2",
                "np": 5,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.152, -3.69], [0, 0], [3.69, -1.152], [0, 0], [1.152, 3.69], [0, 0], [-3.69, 1.152], [0, 0]],
                            "o": [[0, 0], [1.152, 3.69], [0, 0], [-3.69, 1.152], [0, 0], [-1.152, -3.69], [0, 0], [3.69, -1.152]],
                            "v": [[1861.208, 1111.749], [1886.121, 1191.558], [1881.524, 1200.325], [1753.446, 1240.409], [1744.678, 1235.813], [1719.765, 1156.005], [1724.362, 1147.237], [1852.441, 1107.153]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 5",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [1, 1, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 3",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [-1792, -1153], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "tr",
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0, "y": 1},
                        "o": {"x": 0.333, "y": 0},
                        "t": 14,
                        "s": [1801.139, 977.164],
                        "to": [0, -35.5],
                        "ti": [0, 35.5]
                    }, {"t": 29, "s": [1801.139, 764.164], "h": 1}, {
                        "i": {"x": 0, "y": 1},
                        "o": {"x": 0.333, "y": 0},
                        "t": 72,
                        "s": [1801.139, 764.164],
                        "to": [0, 35.5],
                        "ti": [0, -35.5]
                    }, {
                        "i": {"x": 0.833, "y": 1},
                        "o": {"x": 0.167, "y": 0},
                        "t": 87,
                        "s": [1801.139, 977.164],
                        "to": [0, 35.5],
                        "ti": [0, 0]
                    }, {
                        "i": {"x": 0, "y": 1},
                        "o": {"x": 0.333, "y": 0},
                        "t": 115,
                        "s": [1801.139, 977.164],
                        "to": [0, -35.5],
                        "ti": [0, 35.5]
                    }, {"t": 130, "s": [1801.139, 764.164], "h": 1}, {
                        "i": {"x": 0, "y": 1},
                        "o": {"x": 0.333, "y": 0},
                        "t": 173,
                        "s": [1801.139, 764.164],
                        "to": [0, 35.5],
                        "ti": [0, -35.5]
                    }, {"t": 188, "s": [1801.139, 977.164]}],
                    "ix": 2
                },
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [594, 594], "ix": 3},
                "r": {"a": 0, "k": 17.3, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }], "nm": "Group 5", "np": 2, "cix": 2, "bm": 0, "ix": 2, "mn": "ADBE Vector Group", "hd": false
        }, {
            "ty": "gr", "it": [{
                "ind": 0, "ty": "sh", "ix": 1, "ks": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 10,
                        "s": [{
                            "i": [[-0.758, -2.403], [0, 0], [0.05, -1.142], [4.2, -1.308], [0, 0], [2.5, 3.352], [0.36, 1.136], [0, 0], [-0.788, 2.059], [-14.49, 5.196], [-2.265, 0.603], [-2.109, -1.321]],
                            "o": [[0, 0], [0.36, 1.157], [-0.18, 4.162], [0, 0], [-4.22, 1.315], [-0.68, -0.903], [0, 0], [-0.707, -2.273], [0.933, -2.439], [2.197, -0.788], [14.919, -3.974], [1.978, 1.239]],
                            "v": [[78.735, -34.708], [103.175, 43.824], [103.625, 47.302], [96.485, 56.565], [-39.905, 99.014], [-51.065, 95.387], [-52.635, 92.318], [-77.065, 13.819], [-76.632, 7.874], [-6.935, -15.232], [0.09, -17.423], [74.435, -40.273]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 11,
                        "s": [{
                            "i": [[-0.758, -2.403], [0, 0], [0.05, -1.142], [4.2, -1.308], [0, 0], [2.5, 3.352], [0.36, 1.136], [0, 0], [-0.788, 2.059], [-13.999, 6.772], [-2.338, 0.367], [-2.109, -1.321]],
                            "o": [[0, 0], [0.36, 1.157], [-0.18, 4.162], [0, 0], [-4.22, 1.315], [-0.68, -0.903], [0, 0], [-0.707, -2.273], [0.933, -2.439], [2.122, -1.027], [15.402, -2.421], [1.978, 1.239]],
                            "v": [[78.735, -34.708], [103.175, 43.824], [103.625, 47.302], [96.485, 56.565], [-39.905, 99.014], [-51.065, 95.387], [-52.635, 92.318], [-77.065, 13.819], [-76.632, 7.874], [-11.418, -32.357], [-4.394, -34.553], [74.435, -40.273]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0, "y": 1},
                        "o": {"x": 0.333, "y": 0},
                        "t": 18,
                        "s": [{
                            "i": [[-0.758, -2.403], [0, 0], [0.05, -1.142], [4.2, -1.308], [0, 0], [2.5, 3.352], [0.36, 1.136], [0, 0], [-0.788, 2.059], [-11.355, 15.263], [-2.734, -0.902], [-2.109, -1.321]],
                            "o": [[0, 0], [0.36, 1.157], [-0.18, 4.162], [0, 0], [-4.22, 1.315], [-0.68, -0.903], [0, 0], [-0.707, -2.273], [0.933, -2.439], [1.721, -2.314], [18.008, 5.945], [1.978, 1.239]],
                            "v": [[78.735, -34.708], [103.175, 43.824], [103.625, 47.302], [96.485, 56.565], [-39.905, 99.014], [-51.065, 95.387], [-52.635, 92.318], [-77.065, 13.819], [-76.632, 7.874], [-21.154, -67.958], [-14.138, -70.18], [74.435, -40.273]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 1, "y": 0},
                        "t": 81,
                        "s": [{
                            "i": [[-0.758, -2.403], [0, 0], [0.05, -1.142], [4.2, -1.308], [0, 0], [2.5, 3.352], [0.36, 1.136], [0, 0], [-0.788, 2.059], [-11.355, 15.263], [-2.734, -0.902], [-2.109, -1.321]],
                            "o": [[0, 0], [0.36, 1.157], [-0.18, 4.162], [0, 0], [-4.22, 1.315], [-0.68, -0.903], [0, 0], [-0.707, -2.273], [0.933, -2.439], [1.721, -2.314], [18.008, 5.945], [1.978, 1.239]],
                            "v": [[78.735, -34.708], [103.175, 43.824], [103.625, 47.302], [96.485, 56.565], [-39.905, 99.014], [-51.065, 95.387], [-52.635, 92.318], [-77.065, 13.819], [-76.632, 7.874], [-21.154, -67.958], [-14.138, -70.18], [74.435, -40.273]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 88,
                        "s": [{
                            "i": [[-0.758, -2.403], [0, 0], [0.05, -1.142], [4.2, -1.308], [0, 0], [2.5, 3.352], [0.36, 1.136], [0, 0], [-0.788, 2.059], [-13.999, 6.772], [-2.338, 0.367], [-2.109, -1.321]],
                            "o": [[0, 0], [0.36, 1.157], [-0.18, 4.162], [0, 0], [-4.22, 1.315], [-0.68, -0.903], [0, 0], [-0.707, -2.273], [0.933, -2.439], [2.122, -1.027], [15.402, -2.421], [1.978, 1.239]],
                            "v": [[78.735, -34.708], [103.175, 43.824], [103.625, 47.302], [96.485, 56.565], [-39.905, 99.014], [-51.065, 95.387], [-52.635, 92.318], [-77.065, 13.819], [-76.632, 7.874], [-11.418, -32.357], [-4.394, -34.553], [74.435, -40.273]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 89,
                        "s": [{
                            "i": [[-0.758, -2.403], [0, 0], [0.05, -1.142], [4.2, -1.308], [0, 0], [2.5, 3.352], [0.36, 1.136], [0, 0], [-0.788, 2.059], [-14.49, 5.196], [-2.265, 0.603], [-2.109, -1.321]],
                            "o": [[0, 0], [0.36, 1.157], [-0.18, 4.162], [0, 0], [-4.22, 1.315], [-0.68, -0.903], [0, 0], [-0.707, -2.273], [0.933, -2.439], [2.197, -0.788], [14.919, -3.974], [1.978, 1.239]],
                            "v": [[78.735, -34.708], [103.175, 43.824], [103.625, 47.302], [96.485, 56.565], [-39.905, 99.014], [-51.065, 95.387], [-52.635, 92.318], [-77.065, 13.819], [-76.632, 7.874], [-6.935, -15.232], [0.09, -17.423], [74.435, -40.273]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 111,
                        "s": [{
                            "i": [[-0.758, -2.403], [0, 0], [0.05, -1.142], [4.2, -1.308], [0, 0], [2.5, 3.352], [0.36, 1.136], [0, 0], [-0.788, 2.059], [-14.49, 5.196], [-2.265, 0.603], [-2.109, -1.321]],
                            "o": [[0, 0], [0.36, 1.157], [-0.18, 4.162], [0, 0], [-4.22, 1.315], [-0.68, -0.903], [0, 0], [-0.707, -2.273], [0.933, -2.439], [2.197, -0.788], [14.919, -3.974], [1.978, 1.239]],
                            "v": [[78.735, -34.708], [103.175, 43.824], [103.625, 47.302], [96.485, 56.565], [-39.905, 99.014], [-51.065, 95.387], [-52.635, 92.318], [-77.065, 13.819], [-76.632, 7.874], [-6.935, -15.232], [0.09, -17.423], [74.435, -40.273]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0, "y": 1},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 112,
                        "s": [{
                            "i": [[-0.758, -2.403], [0, 0], [0.05, -1.142], [4.2, -1.308], [0, 0], [2.5, 3.352], [0.36, 1.136], [0, 0], [-0.788, 2.059], [-13.999, 6.772], [-2.338, 0.367], [-2.109, -1.321]],
                            "o": [[0, 0], [0.36, 1.157], [-0.18, 4.162], [0, 0], [-4.22, 1.315], [-0.68, -0.903], [0, 0], [-0.707, -2.273], [0.933, -2.439], [2.122, -1.027], [15.402, -2.421], [1.978, 1.239]],
                            "v": [[78.735, -34.708], [103.175, 43.824], [103.625, 47.302], [96.485, 56.565], [-39.905, 99.014], [-51.065, 95.387], [-52.635, 92.318], [-77.065, 13.819], [-76.632, 7.874], [-11.418, -32.357], [-4.394, -34.553], [74.435, -40.273]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0, "y": 1},
                        "o": {"x": 0.333, "y": 0},
                        "t": 119,
                        "s": [{
                            "i": [[-0.758, -2.403], [0, 0], [0.05, -1.142], [4.2, -1.308], [0, 0], [2.5, 3.352], [0.36, 1.136], [0, 0], [-0.788, 2.059], [-11.355, 15.263], [-2.734, -0.902], [-2.109, -1.321]],
                            "o": [[0, 0], [0.36, 1.157], [-0.18, 4.162], [0, 0], [-4.22, 1.315], [-0.68, -0.903], [0, 0], [-0.707, -2.273], [0.933, -2.439], [1.721, -2.314], [18.008, 5.945], [1.978, 1.239]],
                            "v": [[78.735, -34.708], [103.175, 43.824], [103.625, 47.302], [96.485, 56.565], [-39.905, 99.014], [-51.065, 95.387], [-52.635, 92.318], [-77.065, 13.819], [-76.632, 7.874], [-21.154, -67.958], [-14.138, -70.18], [74.435, -40.273]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 1, "y": 0},
                        "t": 182,
                        "s": [{
                            "i": [[-0.758, -2.403], [0, 0], [0.05, -1.142], [4.2, -1.308], [0, 0], [2.5, 3.352], [0.36, 1.136], [0, 0], [-0.788, 2.059], [-11.355, 15.263], [-2.734, -0.902], [-2.109, -1.321]],
                            "o": [[0, 0], [0.36, 1.157], [-0.18, 4.162], [0, 0], [-4.22, 1.315], [-0.68, -0.903], [0, 0], [-0.707, -2.273], [0.933, -2.439], [1.721, -2.314], [18.008, 5.945], [1.978, 1.239]],
                            "v": [[78.735, -34.708], [103.175, 43.824], [103.625, 47.302], [96.485, 56.565], [-39.905, 99.014], [-51.065, 95.387], [-52.635, 92.318], [-77.065, 13.819], [-76.632, 7.874], [-21.154, -67.958], [-14.138, -70.18], [74.435, -40.273]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 189,
                        "s": [{
                            "i": [[-0.758, -2.403], [0, 0], [0.05, -1.142], [4.2, -1.308], [0, 0], [2.5, 3.352], [0.36, 1.136], [0, 0], [-0.788, 2.059], [-13.999, 6.772], [-2.338, 0.367], [-2.109, -1.321]],
                            "o": [[0, 0], [0.36, 1.157], [-0.18, 4.162], [0, 0], [-4.22, 1.315], [-0.68, -0.903], [0, 0], [-0.707, -2.273], [0.933, -2.439], [2.122, -1.027], [15.402, -2.421], [1.978, 1.239]],
                            "v": [[78.735, -34.708], [103.175, 43.824], [103.625, 47.302], [96.485, 56.565], [-39.905, 99.014], [-51.065, 95.387], [-52.635, 92.318], [-77.065, 13.819], [-76.632, 7.874], [-11.418, -32.357], [-4.394, -34.553], [74.435, -40.273]],
                            "c": true
                        }]
                    }, {
                        "t": 190,
                        "s": [{
                            "i": [[-0.758, -2.403], [0, 0], [0.05, -1.142], [4.2, -1.308], [0, 0], [2.5, 3.352], [0.36, 1.136], [0, 0], [-0.788, 2.059], [-14.49, 5.196], [-2.265, 0.603], [-2.109, -1.321]],
                            "o": [[0, 0], [0.36, 1.157], [-0.18, 4.162], [0, 0], [-4.22, 1.315], [-0.68, -0.903], [0, 0], [-0.707, -2.273], [0.933, -2.439], [2.197, -0.788], [14.919, -3.974], [1.978, 1.239]],
                            "v": [[78.735, -34.708], [103.175, 43.824], [103.625, 47.302], [96.485, 56.565], [-39.905, 99.014], [-51.065, 95.387], [-52.635, 92.318], [-77.065, 13.819], [-76.632, 7.874], [-6.935, -15.232], [0.09, -17.423], [74.435, -40.273]],
                            "c": true
                        }]
                    }],
                    "ix": 2
                }, "nm": "Path 4", "mn": "ADBE Vector Shape - Group", "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.3764705882352941, 0.44313725490196076, 1, 1], "ix": 4},
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 3",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [1801.139, 934.164], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [594, 594], "ix": 3},
                "r": {"a": 0, "k": 17.3, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }], "nm": "back 2", "np": 2, "cix": 2, "bm": 0, "ix": 3, "mn": "ADBE Vector Group", "hd": false
        }, {
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[-0.758, -2.403], [0, 0], [0.05, -1.142], [4.2, -1.308], [0, 0], [2.5, 3.352], [0.36, 1.136], [0, 0], [-0.788, 2.059], [-14.49, 5.196], [-2.265, 0.603], [-2.109, -1.321]],
                        "o": [[0, 0], [0.36, 1.157], [-0.18, 4.162], [0, 0], [-4.22, 1.315], [-0.68, -0.903], [0, 0], [-0.707, -2.273], [0.933, -2.439], [2.197, -0.788], [14.919, -3.974], [1.978, 1.239]],
                        "v": [[78.735, -34.708], [103.175, 43.824], [103.625, 47.302], [96.485, 56.565], [-39.905, 99.014], [-51.065, 95.387], [-52.635, 92.318], [-77.065, 13.819], [-76.632, 7.874], [-6.935, -15.232], [0.09, -17.423], [74.435, -40.273]],
                        "c": true
                    },
                    "ix": 2
                },
                "nm": "Path 5",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0, 0, 0, 1], "ix": 4},
                "o": {"a": 0, "k": 20, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 4",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [1785.139, 947.164], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [594, 594], "ix": 3},
                "r": {"a": 0, "k": 17.3, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "back",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 4,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 204,
        "st": -23,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 10,
        "ty": 4,
        "nm": "Shape Layer 1",
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [480, 540, 0], "ix": 2},
            "a": {"a": 0, "k": [0, 0, 0], "ix": 1},
            "s": {"a": 0, "k": [91, 91.91, 100], "ix": 6}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr", "it": [{
                "ind": 0, "ty": "sh", "ix": 1, "ks": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 0,
                        "s": [{
                            "i": [[-194.546, 54.872], [46, -283], [202.136, 0], [53.627, 210.319]],
                            "o": [[234, -66], [-34.823, 214.236], [-202.136, 0], [-64, -251]],
                            "v": [[-58, -395], [382, -4], [-28, 403], [-382, 2]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 50,
                        "s": [{
                            "i": [[-201.9, 9.769], [46, -283], [198.441, -38.473], [-30.055, 214.957]],
                            "o": [[248, -12], [-34.823, 214.236], [-196, 38], [46, -329]],
                            "v": [[-86, -411], [416, 26], [-28, 369], [-384, 26]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 99,
                        "s": [{
                            "i": [[-189.571, 70.156], [-42, -269], [198.441, -38.473], [0, 217.048]],
                            "o": [[254, -94], [50.213, 321.602], [-196, 38], [0, -265]],
                            "v": [[-86, -411], [416, 26], [-74, 309], [-430, -32]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 150,
                        "s": [{
                            "i": [[-263.72, 24.16], [16.66, -322.3], [194.54, 24.06], [76.48, 256.34]],
                            "o": [[263.72, -24.16], [-16.66, 322.3], [-198.486, -24.548], [-76.48, -256.34]],
                            "v": [[-47.72, -384.84], [380.66, 62.7], [-56.54, 346.94], [-379.52, 15.34]],
                            "c": true
                        }]
                    }, {
                        "t": 199,
                        "s": [{
                            "i": [[-194.546, 54.872], [46, -283], [202.136, 0], [53.627, 210.319]],
                            "o": [[234, -66], [-34.823, 214.236], [-202.136, 0], [-64, -251]],
                            "v": [[-58, -395], [382, -4], [-28, 403], [-382, 2]],
                            "c": true
                        }]
                    }],
                    "ix": 2
                }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.8, 0.8, 0.8, 1], "ix": 4},
                "o": {"a": 0, "k": 20, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [2, -19], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }], "nm": "Ellipse 3", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
        }, {
            "ty": "gr", "it": [{
                "ind": 0, "ty": "sh", "ix": 1, "ks": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 0,
                        "s": [{
                            "i": [[-194.546, 54.872], [46, -283], [202.136, 0], [53.627, 210.319]],
                            "o": [[234, -66], [-34.823, 214.236], [-202.136, 0], [-64, -251]],
                            "v": [[-58, -395], [382, -4], [-28, 403], [-382, 2]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 50,
                        "s": [{
                            "i": [[-201.9, 9.769], [46, -283], [198.441, -38.473], [-30.055, 214.957]],
                            "o": [[248, -12], [-34.823, 214.236], [-196, 38], [46, -329]],
                            "v": [[-86, -411], [416, 26], [-28, 369], [-384, 26]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 99,
                        "s": [{
                            "i": [[-189.571, 70.156], [-42, -269], [198.441, -38.473], [0, 217.048]],
                            "o": [[254, -94], [50.213, 321.602], [-196, 38], [0, -265]],
                            "v": [[-86, -411], [416, 26], [-74, 309], [-430, -32]],
                            "c": true
                        }]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 150,
                        "s": [{
                            "i": [[-263.72, 24.16], [16.66, -322.3], [194.54, 24.06], [76.48, 256.34]],
                            "o": [[263.72, -24.16], [-16.66, 322.3], [-198.486, -24.548], [-76.48, -256.34]],
                            "v": [[-47.72, -384.84], [380.66, 62.7], [-56.54, 346.94], [-379.52, 15.34]],
                            "c": true
                        }]
                    }, {
                        "t": 199,
                        "s": [{
                            "i": [[-194.546, 54.872], [46, -283], [202.136, 0], [53.627, 210.319]],
                            "o": [[234, -66], [-34.823, 214.236], [-202.136, 0], [-64, -251]],
                            "v": [[-58, -395], [382, -4], [-28, 403], [-382, 2]],
                            "c": true
                        }]
                    }],
                    "ix": 2
                }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
            }, {
                "ty": "fl",
                "c": {"a": 0, "k": [0.3764705882352941, 0.44313725490196076, 1, 1], "ix": 4},
                "o": {"a": 0, "k": 15, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [2, -75], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [112, 112], "ix": 3},
                "r": {"a": 0, "k": -174, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }], "nm": "Ellipse 2", "np": 2, "cix": 2, "bm": 0, "ix": 2, "mn": "ADBE Vector Group", "hd": false
        }],
        "ip": 0,
        "op": 200,
        "st": 0,
        "bm": 0
    }],
    "markers": []
}